module.exports = __webpack_public_path__ + "media/icons/group-4d44a53b.png";